import React, { useContext } from 'react'
import { Tab } from 'react-bootstrap'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { Tabs } from '../tabs'
import { BaseUploadOptions, ExtendedOption, ScanEngine } from './types'
import { BaseScanOptions } from './base-options'
import { ExtendedScanOptions } from './extended-options'
import { allowedFeaturesStorage } from 'app/modules/auth/helper/storage'
import { Feature } from 'app/modules/auth/types'
import { applicationConfiguration } from '../../../shared'
import { ScanProfile, ScanProfileOptions } from 'app/modules/user/features/profile/types'

type UploadOptionsProps = {
  baseOptions: BaseUploadOptions
  extendedOptions: ScanProfileOptions
  setBaseOptions: CallableFunction
  setExtendedOptions: CallableFunction
  scanProfiles: ScanProfile[]
  activeScanProfile: string | undefined
  setActiveScanProfile: CallableFunction
  activeScanEngine: ScanEngine | undefined
  setActiveScanEngine: CallableFunction
  fields: ExtendedOption[]
  error: string | undefined
  setError: CallableFunction
  activeTab: string
  setActiveTab: CallableFunction
}
export function UploadOptions({
  baseOptions,
  extendedOptions,
  setBaseOptions,
  setExtendedOptions,
  error,
  setError,
  activeTab,
  setActiveTab,
  scanProfiles,
  activeScanProfile,
  setActiveScanProfile,
  activeScanEngine,
  setActiveScanEngine,
  fields,
}: UploadOptionsProps) {
  const { _t } = useTypedTranslation()
  const config = useContext(applicationConfiguration)
  const features = allowedFeaturesStorage.getFeatures()
  const isAdvancedScanningAllowed = features && features.indexOf(Feature.Advanced_scanning) !== -1

  return (
    <Tabs onSelect={(key: string) => setActiveTab(key)} activeKey={activeTab}>
      <Tab title={_t('base-options')} eventKey="base-options" tabClassName={error ? 'with-badge red-badge' : ''}>
        <i className="d-inline-block text-muted mb-3">{_t('base-scan-options-note')}</i>

        <BaseScanOptions data={baseOptions} setData={setBaseOptions} error={error} setError={setError} />
      </Tab>

      {config.buildType === 'community' || isAdvancedScanningAllowed ? (
        <Tab title={_t('extended-options')} eventKey="extended-options">
          <ExtendedScanOptions
            data={extendedOptions}
            setData={setExtendedOptions}
            disabled={!isAdvancedScanningAllowed}
            scanProfiles={scanProfiles}
            activeScanProfile={activeScanProfile}
            setActiveScanProfile={setActiveScanProfile}
            activeScanEngine={activeScanEngine}
            setActiveScanEngine={setActiveScanEngine}
            fields={fields}
          />
        </Tab>
      ) : null}
    </Tabs>
  )
}
